module.exports = "/_next/static/images/85b72a3cf55d78fa7dda868862b8c119-device-frame@0.5x.png.webp";